import { call, put, takeLatest } from 'redux-saga/effects';
import apiCall from '../helpers/ApiCall';
import apiRoot from '../consts/apiRoot';
import { FETCH_AD, FETCH_AD_FAIL, FETCH_AD_SUCCESS } from '../redux/Ads';
import { GET } from '../consts/Methods';
import { SET_LOADER } from '../redux/Loader';

function* FetchAdFlow({ payload, }) {
  try {
    const endpoint = `${apiRoot}/ads/${payload}`;
    yield put(SET_LOADER({ value: true, }));
    const response = yield call(apiCall, { method: GET, endpoint, });
    yield put(FETCH_AD_SUCCESS(response));
  } catch (error) {
    yield put(FETCH_AD_FAIL(error));
  } finally {
    yield put(SET_LOADER({ value: false, }));
  }
}

export default function* FetchAd() {
  yield takeLatest(FETCH_AD, FetchAdFlow);
}
